import $ from 'jquery';

export function init() {
  $('.extended_label_extend').on('click', function () {
    $('#searchform_extended').removeClass("searchform_extended");
    $('#searchform_main').addClass("is_extended");
    $('.searchform-container').addClass("searchform-container-extended");
    $('.jumbotron').toggleClass("col-md-8 col-md-6").toggleClass("col-sm-6 col-sm-4").toggleClass("big small");
  });

  $('.extended_label_simple').on('click', function () {
    $('#searchform_extended').addClass("searchform_extended");
    $('#searchform_main').removeClass("is_extended");
    $('.searchform-container').removeClass("searchform-container-extended");
    var $jumbotron = $('.jumbotron');
    $jumbotron.toggleClass("col-md-8 col-md-6").toggleClass("col-sm-6 col-sm-4").toggleClass("big small");
  });
}